<template>
  <div class="cm-main">
    <div class="cm-container">
      <div class="complaint-main">
        <div class="goods-info">
          <div class="img"><img :src="dataInfo.PicUrl" alt=""></div>
          <div class="desc">
            <div class="desc-title">
              <!-- <span class="platform-tag pdd" v-if="dataInfo.ShopType === 2">拼多多</span>
              <span class="platform-tag tm" v-if="dataInfo.ShopType === 1">天猫</span> -->
              <plat-formLogo :shopType="$utils.shopTypeNumChangeToText(dataInfo.ShopType)"></plat-formLogo>
              <template>{{dataInfo.TitleShort || '----'}}</template>
            </div>
            <p class="desc-time">{{dataInfo.CreateTime | formatTime}}</p>
          </div>
          <div
            :class="{
              'expression': true,
              'bade': dataInfo.ComplainType === 0,
              'commonly': dataInfo.ComplainType === 1,
              'ok': dataInfo.ComplainType === 2
            }">
              <i class="icon iconfont icon-bugaoxing"></i>{{dataInfo.ComplainType | filterText}}
          </div>
        </div>
        <div class="complaint-cnt">{{dataInfo.ComplainRemark || '----'}}</div>
        <div class="complaint-imglist" v-if="imgList.length > 0">
          <div
            v-for="(item, index) in imgList"
            :key="index"
            class="complaint-img"
            @click="previewImage(index)">
              <img :src="item" alt="">
          </div>
        </div>
        <div class="complaint-tip" v-if="dataInfo.AuditStatus === 0">客服小姐姐正在核实情况，请耐心等待哈~ </div>
      </div>
      <!-- 回复 -->
      <div class="complaint-reply" v-if="dataInfo.AuditStatus !== 0">
        <div class="complaint-reply-tile"><i class="icon iconfont icon-pingjia"></i>投诉回复</div>
        <div class="complaint-reply-cnt">
          <div class="cs-icon"><img src="@/assets/icon/customer.jpg" alt=""></div>
          <div class="complaint-reply-desc">
            <p>客服</p>
            <p>{{dataInfo.AuditRemark || '----'}}</p>
            <p>{{dataInfo.AuditTime | formatTime}}</p>
          </div>
        </div>
      </div>
      <div class='order-btn b_fff flex'>
        <div>
          <mt-button type="default" @click="goBack">返回</mt-button>
        </div>
        <div class="btn-margin">
          <mt-button
            v-if="dataInfo.AuditStatus === 2"
            type="danger"
            @click="complaintAgain" >重新投诉
          </mt-button>
        </div>
      </div>
    </div>
    <preview-dialog
      v-if="previewDialogShow"
      @close="previewDialogShow = false"
      :img-src="previewImgSrc">
    </preview-dialog>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { GetComplainInfo } from '@/api/complain'
import moment from 'moment'
export default {
  name: 'ComplaintDetail',
  data () {
    return {
      previewDialogShow: false,
      previewImgSrc: '',
      productId: '',
      taskId: '',
      dataInfo: {}
    }
  },
  mounted () {
    this.productId = this.$route.query.productId
    this.taskId = this.$route.query.taskId
    if (this.taskId) {
      this.fetchData()
      // 魅族4.4.4
      window.scroll(0, 0)
    } else {
      Toast('无任务id')
      this.$router.go(-1)
    }
  },
  components: {
    PreviewDialog
  },
  computed: {
    imgList () {
      if (!this.dataInfo.ComplainPic) return []
      return this.dataInfo.ComplainPic.split(',')
    }
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      GetComplainInfo({ taskId: this.taskId }).then(res => {
        Indicator.close()
        this.dataInfo = res.Data
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    goBack () {
      this.$router.replace({
        name: 'order',
        query: {
          tabIndex: 3
        }
      })
    },
    complaintAgain () {
      if (this.dataInfo.AuditStatus !== 2) return
      this.$router.replace({
        name: 'complaintPage',
        query: {
          productId: this.productId,
          taskId: this.taskId
        }
      })
    },
    previewImage (index) {
      this.previewDialogShow = true
      this.previewImgSrc = this.imgList[index]
    }
  },
  filters: {
    formatTime (val) {
      if (!val) return '--:----'
      return moment(val).format('YYYY年MM月DD日')
    },
    filterText (val) {
      if (val === 0) {
        return '极度不满'
      } else if (val === 1) {
        return '不满意'
      } else if (val === 2) {
        return '一般'
      } else {
        return '--'
      }
    }
  }
}
</script>

<style scoped>
  .cm-main .preview{
    position:fixed;
    z-index: 999;
  }
  .cm-container{
    width: 100%;
    min-height: 88vh;
    overflow: scroll;
    background: #f2f2f2;
    font-size: 14px;
    padding-bottom: 70px;
  }
  .complaint-main{
    width: 100%;
    background: #fff;
    padding: 0 2% 3%;
    box-sizing: border-box;
  }
  .goods-info{
    position: relative;
    height: 80px;
    display: flex;
    padding: 10px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    font-size: 14px;
  }
  .goods-info .img{
    height: 60px;
    width: 60px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .goods-info .desc{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 52%;
  }
  .goods-info .expression{
    position: absolute;
    top: 10px;
    right: 0;
  }
  .expression.bade{
    color: #ff0000;
  }
  .expression.commonly{
    color: #ff9900;
  }
  .expression.ok{
    color: #3e9fff;
  }
  .expression .icon{
    font-size: 18px;
    margin-right: 5px;
    vertical-align: middle
  }
  .goods-info .desc-title{
    max-height: 50px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
  }
  .goods-info .desc-time{
    color: #999;
    font-size: 13px;
  }
  .goods-info .img > img{
    height: 100%;
    width: 100%;
    display: block;
    border-radius: 5px;
  }
  .complaint-cnt{
    padding: 10px 10px;
  }
  .complaint-tip{
    position: relative;
    height: 40px;
    line-height: 40px;
    background: #f2f1f1;
    padding: 0 10px;
    margin: 15px 10px 0;
    box-sizing: border-box;
    border-radius: 5px;
  }
  .complaint-tip::before{
    content: '';
    position: absolute;
    top: -17px;
    left: 15px;
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom: 10px solid #f2f1f1;
  }
  .complaint-imglist{
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .complaint-img{
    width: 85px;
    height: 85px;
    margin-right: 10px;
  }
  .complaint-img img{
    width: 100%;
    height: 100%;
  }
  /* 回复 */
  .complaint-reply{
    background: #fff;
    padding: 0 10px;
  }
  .complaint-reply-tile{
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    border-bottom: 1px solid #eee;
    margin-right: 5px;
  }
  .complaint-reply-tile .icon{
    margin-right: 5px;
    font-size: 20px;
    vertical-align: middle;
  }
  .complaint-reply-cnt{
    display: flex;
    margin-right: 5px;
    padding: 10px 0;
    min-height: 75px;
  }
  .complaint-reply-cnt .cs-icon{
    flex-shrink: 0;
    width: 40px;
    margin-right: 10px;
  }
  .complaint-reply-cnt .cs-icon img{
    width: 100%;
    height: 40px;
    border-radius: 50%;
  }
  .complaint-reply-desc{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .complaint-reply-desc > p:nth-child(1){
    color: #999;
    font-size: 16px;
  }
  /*.complaint-reply-desc > p:nth-child(2){
    max-height: 80px;
    overflow: hidden;
    -webkit-line-clamp: 4;
    text-overflow: ellipsis;
  }*/
  .complaint-reply-desc > p:nth-child(3){
    color: #999;
    font-size: 13px;
  }
  .order-btn{
    justify-content:flex-end;
    position: fixed;
    align-items: center;
    bottom: 0;
    height: 65px;
    line-height: 65px;
    width: 100%;
    z-index:100;
    box-sizing: border-box;
    overflow: hidden;
  }
  .order-btn button{
    font-size: 14px;
    padding: 0px 15px;
    height: 2.5em;
    line-height: 2.5em;
    margin: 0;
  }
  .order-btn .btn-margin {
    margin: 0 15px;
  }
</style>
